export default {

    formatNb(val) {
        return val
        // console.log(`${val} -> ${new Intl.NumberFormat('fr-FR').format(parseFloat(val))}`)
        /* eslint-disable */
        return new Intl.NumberFormat('en-US').format(parseFloat(val))
        // if (val !== undefined  val !== null) {
        //      /* eslint-disable */
        //     return format("### ### ### ###.##", val)
        // }
        // } else {
        //     return val
        // }
    },

    getUnit(unitCode, toSymbol) {
        let unit
        switch(unitCode) {
            case 1:
                unit = (toSymbol) ? '%' : 'percent'
                break
            case 2:
                unit = (toSymbol) ? 'kWh' : 'raw'
                break
            case 3:
                unit = (toSymbol) ? '_unite_monetaire_' : 'currency'
                break
            default:
                unit = null
        }
        return unit
    },

    getComputedValue(value, digit, constant, unitCode) {
        let result
        switch(unitCode) {
            case 1:
                // Percent
                // console.log('Percent :')
                // console.log(`Math.round((${value} * ${constant}) * 100 * Math.pow(10, ${digit})) / Math.pow(10, ${digit})`)
                result = this.formatNb(Math.round((value / constant) * 100 * Math.pow(10, digit)) / Math.pow(10, digit))
                // console.log(`${result} %`)
                break
            case 2:
                // kWh
                // console.log('kWh :')
                // console.log(`Math.round((${value} * Math.pow(10, ${digit})) / Math.pow(10, ${digit})`)
                result = this.formatNb(Math.round(value * Math.pow(10, digit)) / Math.pow(10, digit))
                // console.log(`${result} kWh`)
                break
            case 3:
                // Currency
                // console.log('Currency :')
                // console.log(`Math.round((${value} * ${constant}) * Math.pow(10, ${digit})) / Math.pow(10, ${digit})`)
                result = this.formatNb(Math.round((value * constant) * Math.pow(10, digit)) / Math.pow(10, digit))
                // console.log(`${result} €`)
                break
            default:
                result = null
        }
        return result
    },

    parsePdmId(pdm) {
        const arr_pdm_path = pdm.split('|')
        return arr_pdm_path[arr_pdm_path.length - 1]
    },

    sort_object_list(a, b) {
        const nameA = a.name.toLowerCase();
        const nameB = b.name.toLowerCase();

        let comp = 0;
        if (nameA > nameB) {
            comp = 1;
        } else if (nameA < nameB) {
            comp = -1;
        }

        return comp;
    }
}
